export const colors = {
  primary: "#6D28D9",
  primaryDark: "#5B21B6",
  primaryLight: "#7C3AED",

  // Status colors
  success: "#10B981",
  warning: "#F59E0B",
  danger: "#EF4444",
  info: "#3B82F6",

  // Backgrounds
  bgPrimary: "#F8FAFC",
  bgCard: "#FFFFFF",
  bgHover: "#F1F5F9",

  // Text
  textPrimary: "#0F172A",
  textSecondary: "#64748B",
  textMuted: "#94A3B8",

  // Borders
  border: "#E2E8F0",
  borderLight: "#F1F5F9",

  // Chart colors
  chartBlue: "#6366F1",
  chartGreen: "#10B981",
  chartPurple: "#8B5CF6",
  chartOrange: "#F59E0B",
  chartPink: "#EC4899",
};

export const shadows = {
  card: "0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.06)",
  cardHover: "0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)",
};

export const getSourceIcon = (source) => {
  const iconMap = {
    facebook: { color: "#1877F2", bg: "#EFF6FF" },
    google: { color: "#EA4335", bg: "#FEF2F2" },
    linkedin: { color: "#0A66C2", bg: "#EFF6FF" },
    instagram: { color: "#E4405F", bg: "#FDF2F8" },
    website: { color: "#64748B", bg: "#F8FAFC" },
  };

  return iconMap[source?.toLowerCase()] || { color: colors.textMuted, bg: colors.bgPrimary };
};
